<template >
  <div class="container-fluid" v-if="lesson">
    <div class="row">
      <div class="col-md-8 col-sm-12" style="padding-bottom:2em;">
        <h3 class="text-center">{{lesson.name}}</h3>
        <div v-if="currentVideo.videoUrl!=null">
          <div>
            <h3>{{currentVideo.name}}</h3>
          </div>
          <div>
            <!-- <iframe width="100%" height="600" frameborder="0" src="https://www.youtube.com/embed/oYiT-vLjhC4" allowfullscreen></iframe> -->
            <iframe
              width="100%"
              height="600"
              v-if="currentVideo.videoUrl!=null && currentVideo.videoUrl!='' && currentVideo.videoUrl.toLowerCase().indexOf('youtube') != -1"
              v-bind:src="getYoutubeIframe(currentVideo.videoUrl)"
              frameborder="0"
              allowfullscreen
            ></iframe>
            <!-- <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe> -->
          </div>
        </div>

        <hr class="mb-5" />
      </div>

      <div class="col-md-4 col-sm-12">
        <div v-if="school && school.university==true">
          <topics
            v-if="topics && topics.length>0"
            :_editTopic="_editTopic"
            :topics="topics"
            :lesson="lesson"
            :schoolId="schoolId"
            :types="types"
            :lessonId="lesson.id"
          ></topics>
          <div v-else class="alert alert-warning text-center mb-4">
            <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
          </div>
        </div>
        <div v-else>
          <div class="card pl-3" v-for="semester in semesters">
            <h4 class="p-3 text-center">Xичээлүүд</h4>
            <div v-for="(topic) in semester.topics" v-bind:key="topic.id" v-if="semester.topics!=null && semester.topics.length>0">
                <h4 class="card-title text-primary mb-0">{{topic.name}}</h4>
                <hr class="mt-0"/>
                <div class="row mb-2" v-for="(item, index) in topic.details" v-bind:key="item.id">
                    <div class="col-md-4">
                    <div>
                        <a style="cursor:pointer" @click="_playVideo(item)">
                            <img style="width: 100%;" src="https://img.youtube.com/vi/WEljsc2jorI/1.jpg" alt="">
                        </a>
                    </div>
                    </div>
                    <div class="col-md-8">
                        <a href="single.html">{{item.name}}</a>
                        <!-- <p class="views">xxx</p> -->
                    </div>
                </div>
            </div>
            
            <div v-else class="alert alert-warning text-center mb-4">
              <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import Topics from "./Topics";
import LessonInfo from "../shared/LessonInfo";
export default {
  name: "IVideoWatcher",

  data() {
    return {
      lesson: null,
      currentVideo: {
          videoUrl: 'https://www.youtube.com/watch?v=m5frhQ_X3T8'
      },
      topic: {
        name: null,
        description: null,
        price: 0,
        tags: [],
        shortname: null,
      },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],
      tmpAdditionalFile: {
        name: "",
        uploading: false,
        uploadPercent: null,
      },
      lessonBucket: "lessonFiles/",
      topicBucket: "lessonTopicFiles/",
      tagText: null,
      school: null,
      semesters: [],
      selectedSemester: null,
    };
  },
  methods: {
    
    _playVideo(video){
        console.log(video.videoUrl);
        this.currentVideo = {videoUrl: video.videoUrl}
    },
    _getQA() {
      fb.db
        .collection("ContentTypes")
        .get()
        .then((querySnapshot) => {
          this.types = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
          });
        });

      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolDoc) => {
          if (schoolDoc.exists) {
            let school = schoolDoc.data();
            school.id = schoolDoc.id;
            this.school = school;

            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .get().then((doc) => {
                let lesson = doc.data();
                lesson.id = doc.id;
                this.lesson = lesson;
              });
            if (school && school.university && school.university == true) {
              fb.db
                .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
                .collection("topics")
                .orderBy("createdAt", "desc")
                .onSnapshot((querySnapshot) => {
                  this.topics = [];
                  querySnapshot.forEach((doc) => {
                    let object = doc.data();
                    object.id = doc.id;
                    object.details = [];
                    if (!object.published) object.published = null;
                    doc.ref
                      .collection("details")
                      .orderBy("createdAt")
                      .onSnapshot((contentSnapshot) => {
                        object.details = [];
                        contentSnapshot.forEach((contentDoc) => {
                          let content = contentDoc.data();
                          content.id = contentDoc.id;
                          content.uploading = false;
                          content.uploadPercent = 0;
                          object.details.push(content);
                        });
                      });
                    this.topics.push(object);
                  });
                });
            } 
            else {
              fb.db
                .collection("schools/" + this.schoolId + "/semester")
                .orderBy("createdAt", "desc")
                .get()
                .then((semesterSnapshot) => {
                  semesterSnapshot.docs.forEach((semesterDoc) => {
                    let semester = semesterDoc.data();
                    semester.id = semesterDoc.id;
                    semester.path = semesterDoc.ref.path;
                    semester.topics = [];
                    fb.db
                      .doc(
                        "schools/" + this.schoolId + "/lessons/" + this.lessonId
                      )
                      .collection("topics")
                      .where("semester", "==", semesterDoc.ref)
                      .orderBy("createdAt", "desc")
                      .onSnapshot((querySnapshot) => {
                        semester.topics = [];
                        querySnapshot.forEach((doc) => {
                          let object = doc.data();
                          object.id = doc.id;
                          object.details = [];
                          doc.ref
                            .collection("details")
                            .orderBy("createdAt")
                            .onSnapshot((contentSnapshot) => {
                              object.details = [];
                              contentSnapshot.forEach((contentDoc) => {
                                let content = contentDoc.data();
                                content.id = contentDoc.id;
                                content.uploading = false;
                                content.uploadPercent = 0;
                                object.details.push(content);
                              });
                            });
                          semester.topics.push(object);
                        });
                      });
                    this.semesters.push(semester);
                  });
                });
            }
          }
        });
    },

    saveTopic() {
      if (
        this.lesson != null &&
        this.topic != null &&
        this.topic.name != "" &&
        this.topic.description != ""
      ) {
        if (this.school.university != true && !this.selectedSemester) {
          alert("Та сэдэв заагдах улирлаа сонгоно уу.");
          return;
        }
        if (this.topic.price != null && this.topic.price == "")
          this.topic.price = 0;
        if (this.selectedSemester)
          this.topic.semester = fb.db.doc(this.selectedSemester.path);
        if (
          this.topic.id != null &&
          this.topic.id != "" &&
          this.topic.id != "new"
        ) {
          this.topic.modifiedAt = new Date();

          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("topics")
            .doc(this.topic.id)
            .update(this.topic);
        } else {
          var now = new Date();
          this.topic.createdAt = now;

          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .collection("topics")
            .doc()
            .set(this.topic);
          fb.db
            .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
            .update({
              numberOfTopics: fb.firestore.FieldValue.increment(1),
            });
        }
        this.topic = {
          name: null,
          description: null,
          price: 0,
          tags: [],
          shortname: null,
        };
        $("#exampleModal").modal("toggle");
      }
    },

    _editTopic(topic) {
      if (topic.semester) {
        this.semesters.forEach((value) => {
          if (value && value.path && value.path == topic.semester.path) {
            this.selectedSemester = value;
          }
        });
      }
      this.topic = Object.assign({}, topic);
      $("#exampleModal").modal("toggle");
    },
    uploadFile(topic, content) {
      var _this = this;
      var files = this.$refs["file_" + content.id][0].files;
      if (files != null && files.length > 0) {
        var file = files[0];
        if (
          file.name.endsWith("mp4") ||
          file.name.endsWith("MP4") ||
          file.name.endsWith("MPEG") ||
          file.name.endsWith("mov") ||
          file.name.endsWith("MOV") ||
          file.name.endsWith("webm") ||
          file.name.endsWith("WEBM")
        ) {
          alert("Та video файл оруулах боломжгүй");
          return;
        }
        var now = new Date();
        var fileName = this.topicBucket + now.getTime() + "_" + file.name;
        var uploadTask = fb.storageRef.child(fileName).put(file);
        content.uploading = true;
        content.uploadPercent = 0;
        uploadTask.on(
          fb.storage.TaskEvent.STATE_CHANGED,
          function (snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            content.uploadPercent = progress;
          },
          function (error) {
            switch (error.code) {
              case "storage/unauthorized":
                break;

              case "storage/canceled":
                break;
              case "storage/unknown":
                break;
            }
          },
          function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                let fileObject = {
                  fileName: fileName,
                  fileUrl: downloadURL,
                  realName: file.name,
                  uploadedAt: now,
                };
                fb.db
                  .doc(
                    "schools/" + this.schoolId + "/lessons/" + _this.lessonId
                  )
                  .collection("topics")
                  .doc(topic.id)
                  .collection("details")
                  .doc(content.id)
                  .update({
                    files: fb.firestore.FieldValue.arrayUnion(fileObject),
                  });
                content.uploading = false;
                content.uploadPercent = 0;
              });
          }
        );
      }
    },
    uploadFile1() {
      if (
        this.tmpAdditionalFile.name != null &&
        this.tmpAdditionalFile.name != ""
      ) {
        var _this = this;
        var files = this.$refs["lessonFile_" + this.lesson.id].files;

        if (files != null && files.length > 0) {
          var file = files[0];
          if (
            file.name.endsWith("mp4") ||
            file.name.endsWith("MP4") ||
            file.name.endsWith("MPEG") ||
            file.name.endsWith("mov") ||
            file.name.endsWith("MOV") ||
            file.name.endsWith("webm") ||
            file.name.endsWith("WEBM")
          ) {
            alert("Та video файл оруулах боломжгүй");
            return;
          }
          var now = new Date();
          var uploadTask = fb.storageRef
            .child(this.lessonBucket + now.getTime() + "_" + file.name)
            .put(file);
          _this.tmpAdditionalFile.uploading = true;
          _this.tmpAdditionalFile.uploadPercent = 0;
          uploadTask.on(
            fb.storage.TaskEvent.STATE_CHANGED,
            function (snapshot) {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              _this.tmpAdditionalFile.uploadPercent = progress;
            },
            function (error) {
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/unauthorized":
                  break;

                case "storage/canceled":
                  break;

                case "storage/unknown":
                  break;
              }
            },
            function () {
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  let fileObject = {
                    title: _this.tmpAdditionalFile.name,
                    fileName: file.name,
                    fileUrl: downloadURL,
                    uploadedAt: now,
                  };
                  fb.db
                    .doc(
                      "schools/" + this.schoolId + "/lessons/" + _this.lessonId
                    )
                    .update({
                      files: fb.firestore.FieldValue.arrayUnion(fileObject),
                    });

                  _this.tmpAdditionalFile = {
                    name: "",
                    uploading: false,
                    uploadPercent: null,
                  };
                  _this.$refs["lessonFile_" + _this.lesson.id].value = "";

                  if (!/safari/i.test(navigator.userAgent)) {
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "";
                    _this.$refs["lessonFile_" + _this.lesson.id].type = "file";
                  }
                });
            }
          );
        }
      }
    },
    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { lessonId: this.lessonId, type: type.id, topicId: topic.id },
      });
    },

    _addTopic() {
      if (this.semesters) {
        this.semesters.forEach((value) => {
          if (value && value.default && value.default == true) {
            this.selectedSemester = value;
          }
        });
      }
      this.topic = {
        name: null,
        description: null,
        price: 0,
        tags: [],
      };
      $("#exampleModal").modal("toggle");
    },

    _deleteLessonFile(file, index) {
      var result = confirm("Та " + file.title + " файлыг устгах уу?");
      if (result) {
        var fileName = file.uploadedAt.toDate().getTime() + "_" + file.fileName;
        var fileRef = fb.storageRef.child(this.lessonBucket + fileName);
        // Delete the file
        fileRef
          .delete()
          .then(() => {
            this.lesson.files.splice(index, 1);
            fb.db
              .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
              .update({
                files: this.lesson.files,
              });
          })
          .catch(function (error) {});
      }
    },

    validFile(file) {
      if (
        file.fileName.endsWith("mp4") ||
        file.fileName.endsWith("MP4") ||
        file.fileName.endsWith("MPEG") ||
        file.fileName.endsWith("mov") ||
        file.fileName.endsWith("MOV") ||
        file.fileName.endsWith("webm") ||
        file.fileName.endsWith("WEBM")
      ) {
        return false;
      }
      return true;
    },
    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return "https://www.youtube.com/embed/" + id;
      }
      return null;
    },

    getType(type) {
      if (type == "test") return "Тест";
      else if (type == "video") return "Видео хичээл";
      else if (type == "lecture") return "Лекц";
      else if (type == "seminar") return "Семинар";
      else if (type == "exam") return "Шалгалт";
      else if (type == "homework") return "Гэрийн даалгавар";
      else if (type == "coursework") return "Бие даалт";
    },
    addTag(tag) {
      if (tag != null && tag != undefined) {
        if (this.topic.tags == null || this.topic.tags == undefined)
          this.topic.tags = [];
        if (!this.topic.tags.includes(tag)) {
          this.topic.tags.push(tag);
        }
        this.tagText = null;
      }
    },
    removeTag(tag, index) {
      if (tag != null && tag != undefined)
        if (this.topic.tags.includes(tag)) {
          this.topic.tags.splice(index, 1);
        }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    Topics,
    LessonInfo,
  },
  props: {
    lessonId: {
      required: true,
    },
    schoolId: {
      required: true,
    },
    sts: {
      required: false,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") this._getQA();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>

